import { api } from '../api/http'

let pushOn = false

/** True after this browser saved a push subscription for the signed-in account. */
export function tournamentPushOn(): boolean {
  return pushOn
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const raw = atob(base64)
  const out = new Uint8Array(raw.length)
  for (let i = 0; i < raw.length; i += 1) out[i] = raw.charCodeAt(i)
  return out
}

/** Registers this browser so the server can deliver tournament notices with the site closed. */
export async function syncPush(token: string): Promise<void> {
  if (!token || typeof Notification === 'undefined') return
  if (Notification.permission !== 'granted') return
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return
  try {
    const key = await api<{ publicKey: string }>('/push/public-key', { token, quiet: true })
    const reg = await navigator.serviceWorker.register('/sw.js')
    const appKey = urlBase64ToUint8Array(key.publicKey)
    let sub = await reg.pushManager.getSubscription()
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: appKey as BufferSource,
      })
    }
    const json = sub.toJSON()
    if (!json.endpoint || !json.keys?.p256dh || !json.keys.auth) return
    await api('/push/subscribe', {
      method: 'POST',
      token,
      quiet: true,
      body: JSON.stringify({
        endpoint: json.endpoint,
        p256dh: json.keys.p256dh,
        auth: json.keys.auth,
      }),
    })
    pushOn = true
  } catch {
    pushOn = false
  }
}

async function dropSubscription(token: string, dropLocal: boolean): Promise<void> {
  pushOn = false
  if (!('serviceWorker' in navigator)) return
  try {
    const reg = await navigator.serviceWorker.getRegistration()
    const sub = await reg?.pushManager.getSubscription()
    if (!sub) return
    if (token) {
      await api('/push/subscribe', {
        method: 'DELETE',
        token,
        quiet: true,
        body: JSON.stringify({ endpoint: sub.endpoint }),
      })
    }
    if (dropLocal) await sub.unsubscribe()
  } catch {
    /* already gone */
  }
}

/** Drops this browser from the signed-out account so the next login can take it. */
export function forgetPush(token: string): void {
  void dropSubscription(token, false)
}

/** Stops tournament push on this browser. The next enable click can subscribe again. */
export function mutePush(token: string): Promise<void> {
  return dropSubscription(token, true)
}
